export enum SnackbarEnum {
    Success = "success",
    Error = "error",
    Warning = "warning",
    Info = "info",
  }
  